import { observer } from 'mobx-react';
import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { useTabs } from '@components/hooks/use-tabs';
import { PageHeader } from '@components/page-header';
import { PageTabs } from '@components/page-tabs';

const pageTabs = [
    { label: 'Global Rules', id: 'global-rules' },
    { label: 'AP Multiplier Groups', id: 'activity-points-rules' },
    { label: 'Validation Rules', id: 'workout-type-rules' },
    { label: 'Type Mappings', id: 'workout-type-mappings' },
    { label: 'Calculated Metrics', id: 'calculated-metrics' }
];

export const WorkoutRules = observer(() => {
    const { tab, getPageLink, setPageTab } = useTabs(pageTabs);
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const changePage = (page: number) => {
        const pageLink = getPageLink(page);
        navigate(pageLink);
    };

    React.useEffect(() => {
        setPageTab(pathname, 2);
    }, [pathname]);

    return (
        <>
            <PageHeader title="Workout Rules" />
            <PageTabs tabs={pageTabs} value={tab} onChange={changePage} />
            <div className="mt-6">
                <Outlet />
            </div>
        </>
    );
});
